<ul class="language">
  <li mat-button [ngClass]="{ current: language === l }" *ngFor="let l of langs" (click)="changeLang(l)">
    <span>{{ l }}</span>
  </li>
</ul>
